import { render, staticRenderFns } from "./ModalSuccessCreatePin.vue?vue&type=template&id=1955861b&"
import script from "./ModalSuccessCreatePin.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessCreatePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports